export default {
    code: 'BUS_US_ASTRAZENECA_PHARMACEUTICAL'
}
